import { Component, Inject, Input, OnChanges, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { Utils } from '../../../../../utils/utils';
import { HttpClient } from '@angular/common/http';
import { MatDialog } from '@angular/material/dialog';
import { CustomDialogService } from '../../../../../services/customdialog.service';
import { ToastrService } from 'ngx-toastr';
import { AssessmentAssignmentPopupComponent } from './assessmentassignmentpopup/assessmentassignmentpopup.component';
import { DefaultValuesService } from '../../../../../services/defaultvalues.service';
import { BranchexcellenceChangelogFormComponent } from '../../branchexcellence-changelog-form/branchexcellence-changelog-form.component';

@Component({
    selector: 'assessment-assignment',
    templateUrl: './assessment-assignment.component.html',
    styleUrls: ['./assessment-assignment.component.less',
        '../branchexcellenceadmin.component.less',
        '../../../../../style/new-generic-styles.component.less'],
    standalone: false
})
export class AssessmentAssignmentComponent implements OnInit, OnChanges {
    public dataSource = new MatTableDataSource<Wave>();

    @Input() selectedWave: Wave | undefined;
    columnsToDisplay = ['Checkbox', 'MgmtId', 'MgmtName', 'AssessmentDate', 'ChangeLog'];

    isRemoveAssignmentEnabled = false;
    removeBranchesList: string[] = []

    constructor(
        private http: HttpClient
        , private dialogForm: MatDialog
        , @Inject('BASE_URL') private baseUrl: string
        , private customDialog: CustomDialogService
        , private toastrService: ToastrService
        , public defaults: DefaultValuesService) { }

    ngOnInit(): void {

    }
    ngOnChanges(): void {
        this.reload()
    }

    reload() {
        this.defaults.notifyManagementIdChange() // to force to load newest waves
        if (this.selectedWave && this.selectedWave?.WaveId !== -1)
            Utils.httpGetAssessments(
                this.http,
                this.baseUrl,
                this.selectedWave!.WaveId,
                this,
                function (tthis: AssessmentAssignmentComponent, list: any) {
                    tthis.dataSource.data = list
                    tthis.isRemoveAssignmentEnabled = false;
                    tthis.removeBranchesList = [];
                },
                null

            )
    }

    openAssignBranchPopup() {
        const dialog = this.dialogForm.open(AssessmentAssignmentPopupComponent, {
            panelClass: ['custom-mat-dialog_v2'],
            disableClose: true,
            minWidth: "60vw",
            data: this.selectedWave
        })

        dialog.afterClosed().subscribe(() => {
            this.reload()
        })
    }

    enableRemoveAssignmentMode() {
        this.isRemoveAssignmentEnabled = !this.isRemoveAssignmentEnabled;
        if (this.isRemoveAssignmentEnabled)
            this.removeBranchesList = [];
    }

    controlAssignedItem(ischecked: boolean, row?: any) {
        if (row) {
            if (ischecked) {
                this.removeBranchesList.push(row.MgmtId);
                return;
            }
            const index = this.removeBranchesList.indexOf(row.MgmtId);
            if (index !== -1) {
                this.removeBranchesList.splice(index, 1);
            }
            return;
        }
        this.removeBranchesList = ischecked
            ? (this.dataSource.data ?? []).map((x: any) => x.MgmtId)
            : [];
    }

    isAllSelected(): boolean {
        const total = this.dataSource.data?.length ?? 0;
        return total > 0 && this.removeBranchesList.length === total;
    }

    isPartiallySelected(): boolean {
        return this.removeBranchesList.length > 0 && !this.isAllSelected();
    }

    confirmRemoveAssignedBranches() {
        Utils.httpUnassignBranchesToWave(
            this.http,
            this.baseUrl,
            this.selectedWave!.WaveId,
            this.removeBranchesList,
            this,
            function (tthis: AssessmentAssignmentComponent, result: any) {
                if (result)
                    tthis.toastrService.success('Entities were unassigned successfully!');
                tthis.reload();
            },
            function (tthis: AssessmentAssignmentComponent, error: string) {
                tthis.toastrService.error('Entities could not be unassigned. Please, contact with administrator');
            }
        )
    }

    onHistoryDetail(element: AssessmentAssignment, type: string) {

        var assesmentAssignemntId = 0;

        if (element.AssessmentId != undefined)
            assesmentAssignemntId = element.AssessmentId;

        const Dialog = this.dialogForm.open(BranchexcellenceChangelogFormComponent, {
            disableClose: false,
            data: {
                element: element,
                id: assesmentAssignemntId,
                dataType: type
            }
        });
        Dialog.afterClosed().subscribe(() => {
        });
    }
}
